import React from 'react';
import { Checkbox, FormControlLabel } from 'lib/cortiUI';
export const GroupTracker = ({ item, onTrackerClick }) => {
    const { title, text, key, isEnabled } = item;
    return (React.createElement(FormControlLabel, { "data-cy": "single-tracker-label", label: text, key: `${key.entityID}`, control: React.createElement(Checkbox, { checked: isEnabled, onChange: (_, checked) => onTrackerClick(title, key, checked) }) }));
};
